let $svg_pgut_pattern_group_before = '<svg preserveAspectRation="none" viewBox="0 0 1920 41" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M1920 36.9516L1920 41.0003L-1.18026e-06 41.0003L-1.06118e-06 36.8637C253.87 13.9514 590.37 0.000489 959.5 0.000489C1329.12 -0.0031717 1666.01 13.9844 1920 36.9516Z" fill="currentColor"/>\n' +
    '</svg>';
let $svg_pgut_pattern_group_after = '<svg preserveAspectRation="none" viewBox="0 0 1920 41" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
    '<path d="M-2.40116e-06 4.04907L-2.66425e-06 0.000334268L1920 0.000166416L1920 4.13676C1666.13 27.0491 1329.63 41.0001 960.5 41.0001C590.88 41.0038 253.99 27.0163 -2.40116e-06 4.04907Z" fill="currentColor"/>\n' +
    '</svg>';


// jQuery(document).ready(function () {
//     pgutAddPatterns();
//     console.log('i');
// });

// front :
jQuery(window).load(function () {
    pgutAddPatterns();
});

// changement dans l'éditeur
/*jQuery(document).ready(function($) {
    const { subscribe } = wp.data;

    // Surveiller les changements dans l'éditeur
    subscribe(function() {
        const blocks = wp.data.select('core/block-editor').getBlocks();

        blocks.forEach(block => {
            if (block.name === 'core/group') {
                pgutRemovePatterns();
                pgutAddPatterns();
                //$(document).trigger('groupBlockChanged', [block]);
            }
        });
    });

    // Écouter l'événement personnalisé avec jQuery
    // $(document).on('groupBlockChanged', function(event, block) {
    //     pgutRemovePatterns();
    //     pgutAddPatterns();
    // });
});*/

function pgutAddPatterns() {
    let $pgut_groups__alignfull = jQuery('.wp-block-group.alignfull.is-style-pattern-before, .wp-block-group.alignfull.is-style-pattern-after, .wp-block-group.alignfull.is-style-pattern-before-and-after');

    $pgut_groups__alignfull.each(function(){
        let $group = jQuery(this);
        let $group_prev = $group.prev();
        let $group_next = $group.next();

        // récupératio nde la classe de couleur pour l'adapter aux patterns
        let $classes = $group.attr('class').split(' ');
        let $color = $classes.find(c => c.includes('-background-color'));
        $color = $color.replace('-background-color', '-color');

        // gestion du pattern before
        if( $svg_pgut_pattern_group_before && (  $group.is('.is-style-pattern-before:not(.pgut-pattern__group__before__is-loaded)') ||  $group.is('.is-style-pattern-before-and-after:not(.pgut-pattern__group__before__is-loaded)') )){
            // ajout du pattern
            let $pgut_pattern_group_before = jQuery('<div class="is-layout-flow alignfull pgut-pattern__group pgut-pattern__group__before pgut-pattern__group__align-full pgut-pattern__group__align-full__before">' + $svg_pgut_pattern_group_before + '</div>').insertBefore($group);
            $group.addClass('pgut-pattern__group__before__is-loaded');
            // accord de la couleur du groupe et du pattern
            $pgut_pattern_group_before.addClass($color);

            // raccord couleur avec le group d'après si /1 il est étendu et 2/ a un background

            if( $group_prev.is('.wp-block-group.alignfull.has-background') ){
                let $classes_prev = $group_prev.attr('class').split(' ');
                let $background_prev = $classes_prev.find(c => c.includes('-background-color'));

                if(!$background_prev){
                    $background_prev = $classes_prev.find(c => c.includes('-gradient-background'));
                }

                $pgut_pattern_group_before.addClass('has-background').addClass($background_prev);

            }
        }

        // gestion du pattern after
        if( $svg_pgut_pattern_group_after && ( $group.is('.is-style-pattern-after:not(.pgut-pattern__group__after__is-loaded)') || $group.is('.is-style-pattern-before-and-after:not(.pgut-pattern__group__after__is-loaded)')) ){
            // ajout du pattern
            let $pgut_pattern_group_after = jQuery('<div class="is-layout-flow alignfull pgut-pattern__group pgut-pattern__group__after pgut-pattern__group__align-full pgut-pattern__group__align-full__after">' + $svg_pgut_pattern_group_after + '</div>').insertAfter($group);
            $group.addClass('pgut-pattern__group__after__is-loaded');

            // accord de la couleur du groupe et du pattern
            $pgut_pattern_group_after.addClass($color);

            // raccord couleur avec le group d'après si /1 il est étendu et 2/ a un background
            if( $group_next.is('.wp-block-group.alignfull.has-background') ){
                let $classes_next = $group_next.attr('class').split(' ');
                let $background_next = $classes_next.find(c => c.includes('-background-color'));

                if(!$background_next){
                    $background_next = $classes_next.find(c => c.includes('-gradient-background'));
                }

                $pgut_pattern_group_after.addClass('has-background').addClass($background_next);

            }
        }

    });
}
function pgutRemovePatterns() {
    jQuery('.pgut-pattern__group__before__is-loaded').removeClass('pgut-pattern__group__before__is-loaded');
    jQuery('.pgut-pattern__group__after__is-loaded').removeClass('pgut-pattern__group__after__is-loaded');

    let $pgut_pattern_group_before = jQuery('.pgut-pattern__group__before');
    $pgut_pattern_group_before.remove();

    let $pgut_pattern_group_after = jQuery('.pgut-pattern__group__after');
    $pgut_pattern_group_after.remove();
}